export default "__VITE_ASSET__18c4af55__"